module.exports = __webpack_public_path__ + "img/suo.9dae3331.png";